import React from "react";
import { Text } from "@jsq/ds/core";
import { type ExtensionFieldValueObjectType } from "~/graphql/supergraphTypes";
import { EmptyValueRenderer } from "./EmptyValueRenderer";

interface NumberFieldRendererProps {
  value: ExtensionFieldValueObjectType;
  fieldType: "integer" | "float";
}

export const NumberFieldRenderer: React.FC<NumberFieldRendererProps> = ({
  value,
  fieldType,
}) => {
  const numericValue = fieldType === "integer" ? value.intValue : value.floatValue;

  if (numericValue === null || numericValue === undefined) {
    return <EmptyValueRenderer />;
  }

  // Format the number based on type
  const formattedValue =
    fieldType === "integer"
      ? numericValue.toString()
      : numericValue.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 6,
        });

  return (
    <Text variant="regular-md" style={{ textAlign: "right" }} title={formattedValue}>
      {formattedValue}
    </Text>
  );
};
